"use script";

angular.module("core")
.constant("CUSTOMER_TYPE", {
    "PERSON": "person",
    "BUSINESS": "business"
});



//////////////////
// WEBPACK FOOTER
// ./core/customer-model/customer.constants.js
// module id = 392
// module chunks = 0